module.exports = __webpack_public_path__ + "img/aliPay.538cbb8d.png";